import React,{useState,useEffect} from "react";
import { FormDialog } from "../GenericReusableComponents/FormDialog";
import { SelectEnvironment } from "../GenericReusableComponents/HTMLWrappers";
import { Table } from "../GenericReusableComponents/Table";
import {promoteBotsFromEnv,getBotDeploymentConfigByEnv} from "../../apis/bots"
import Loading from "../Loading";
export function PromoteBots({show,setShow}){

    const [promoteBotEnvSelected,setPromoteBotEnvSelected] = useState("DEV");
    const [promoteBotButtonLabel,setShowPromoteBotButtonLabel] = useState("");
    const [promoteBotDeploymentProfile,setPromoteBotDeploymentProfile] = useState([]);
    const [promoteBotStatus, setPromotBotsStatus] = useState("");
    const [loading,setLoading] = useState(false);

    useEffect(()=>{
        let mounted = true;
        setLoading(true);
        if(mounted){

            getBotDeploymentConfigByEnv(promoteBotEnvSelected).then((botAgentLinkList)=>{
                setPromoteBotDeploymentProfile(botAgentLinkList);
                setShowPromoteBotButtonLabel("Promote To "+getNextEnvForPromotion(promoteBotEnvSelected));
                setLoading(false);
            })

        }
        return () => (mounted = false);
    },[promoteBotEnvSelected])
    
    function getPromotesBotTableHeader(){
        const columns = ["Bot Name","Agents"];
        return(
            columns.map(i =>(
                <th>{i}</th>
              ))
        )
    
      }
    
      function getPromoteBotsTableBody(){
    
        return promoteBotDeploymentProfile.map(item => (
          <tr >
              <td>{item.botName}</td>
              <td>{item.agentName}</td>    
          </tr>
        ))
    }

    function onSourceEnvSelectForPromoteBots(e){
        e.preventDefault();
        setPromoteBotEnvSelected(e.target.value);
    }
    
    function getNextEnvForPromotion(envSelected){
        if(envSelected === "DEV"){
            return "QA";
        }
    
        if(envSelected === "QA"){
            return "UAT";
        }
    
        if(envSelected === "UAT"){
            return "PROD";
        }
    }

    function getFormElementsForPromoteBotsModal(){
        return (
          <>
            <Loading loading={loading}/>
            <SelectEnvironment selectedEnv={promoteBotEnvSelected} onChangeHandler={onSourceEnvSelectForPromoteBots}/>
            <Table 
              columns={getPromotesBotTableHeader()} 
              rows={getPromoteBotsTableBody()} 
              tbcontainerstyle={{marginLeft:'60px',marginRight:'10px',marginTop:'20px',padding:'0'}} 
              tbscrollstyle={{height:'300px'}}/>
            <p>{promoteBotStatus}</p>
          </>
        ) 
      }

    function formSubmitPromoteBot(){
    
        console.log(`Inside formSubmitPromoteBot ${promoteBotEnvSelected} ${getNextEnvForPromotion()}`)
        promoteBotsFromEnv(promoteBotEnvSelected,getNextEnvForPromotion(promoteBotEnvSelected),afterBotsArePromoted);
    }

    function afterBotsArePromoted(){

        console.log("afterBotsArePromoted")
        setPromotBotsStatus("Successfully Promoted Bots to " + getNextEnvForPromotion(promoteBotEnvSelected));
        setTimeout(() => {
          setPromotBotsStatus("");
          setShow(false);
        },3000);
        
    }

   

    if(!show){
        return <></>
    }
    return(

        <FormDialog 
        showDialog={show} 
        setShowDialog={setShow} 
        formHeader="Promote Bots" 
        formElements= {getFormElementsForPromoteBotsModal()} 
        submitButtonMessage={promoteBotButtonLabel} 
        onFormSubmit={formSubmitPromoteBot}
        closeAfterAction={false}/> 
    )

}